import { jsxs as d, Fragment as x, jsx as e } from "react/jsx-runtime";
import { Field as s } from "react-final-form";
import { useTranslation as _ } from "react-i18next";
import { ExpandMore as v } from "@mui/icons-material";
import c from "@mui/material/Box";
import E from "@mui/material/Divider";
import I from "@mui/material/FormControl";
import N from "@mui/material/InputAdornment";
import R from "@mui/material/MenuItem";
import p from "@mui/material/TextField";
import i from "@mui/material/Typography";
import { makeStyles as U } from "tss-react/mui";
import { BUS_TYPE as l, FIELD_NAME as h } from "../../constant/index.js";
import g from "./AdditionalInfoForm.style.js";
const y = U()(g), F = () => {
  const { classes: r } = y(), { t: o } = _(), u = {
    [l.LUXURY]: o("luxury"),
    [l.SEMI_LUXURY]: o("semi-luxury"),
    [l.REGULAR]: o("regular")
  }, m = [
    {
      id: 1,
      modal: o("luxury"),
      code: l.LUXURY
    },
    {
      id: 2,
      modal: o("semi-luxury"),
      code: l.SEMI_LUXURY
    },
    {
      id: 1,
      modal: o("regular"),
      code: l.REGULAR
    }
  ];
  return /* @__PURE__ */ d(x, { children: [
    /* @__PURE__ */ e(i, { variant: "h6", className: r.groupLabel, children: o("additional_information") }),
    /* @__PURE__ */ e(
      E,
      {
        sx: { marginTop: 2, marginBottom: 2 },
        className: r.divider
      }
    ),
    /* @__PURE__ */ d(c, { mb: { xs: 3 }, children: [
      /* @__PURE__ */ e(i, { variant: "h6", className: r.inputLabel, children: o("preferred_bus_type_(optional)") }),
      /* @__PURE__ */ e(I, { variant: "outlined", className: r.formGroup, children: /* @__PURE__ */ e(s, { name: h.PREFERRED_BUS_TYPE, children: ({ input: n, meta: t }) => /* @__PURE__ */ e(
        p,
        {
          id: "location-select",
          select: !0,
          variant: "outlined",
          InputProps: {
            placeholder: o("select_one_of_our_branches"),
            className: r.inputField,
            endAdornment: /* @__PURE__ */ e(
              N,
              {
                position: "end",
                className: r.arrowAdornment,
                "aria-controls": "arrow-dropdown",
                "aria-haspopup": "true",
                children: /* @__PURE__ */ e(v, { className: r.expandIcon })
              }
            ),
            value: n.value,
            onChange: (a) => {
              n.onChange(a);
            }
          },
          SelectProps: {
            classes: {
              icon: r.defaultIcon
            },
            MenuProps: {
              classes: {
                list: r.menuList
              }
            },
            renderValue: () => n != null && n.value ? u[n == null ? void 0 : n.value] : ""
          },
          error: t.error && t.touched,
          helperText: t.error && t.touched && /* @__PURE__ */ e("span", { "data-testid": "reservationLocationError", children: t.error }),
          children: m == null ? void 0 : m.map((a) => {
            const f = (a == null ? void 0 : a.id) ?? 0;
            return /* @__PURE__ */ e(
              R,
              {
                value: a == null ? void 0 : a.code,
                className: r.menuItem,
                sx: { padding: 2 },
                children: /* @__PURE__ */ e(
                  i,
                  {
                    variant: "h5",
                    className: r.menuItemText,
                    children: a == null ? void 0 : a.modal
                  }
                )
              },
              f
            );
          })
        }
      ) }) })
    ] }),
    /* @__PURE__ */ d(c, { mt: { xs: 3 }, children: [
      /* @__PURE__ */ e(i, { variant: "h6", className: r.inputLabel, children: o("remarks_(optional)_web") }),
      /* @__PURE__ */ e(s, { name: h.MESSAGE, children: ({ input: n }) => /* @__PURE__ */ e(
        p,
        {
          className: r.formField,
          variant: "outlined",
          multiline: !0,
          rows: 6,
          placeholder: o("enter_remarks"),
          "data-testid": "reservationRemarks",
          InputProps: {
            className: r.inputField,
            // ...input,
            // value: input.value,
            onBlur: (t) => n.onChange(t)
          }
        }
      ) })
    ] })
  ] });
}, j = F;
export {
  j as default
};
